import { RestrictivePracticeType } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const restrictivePracticeTypeOptions = {
  [RestrictivePracticeType.ChemicalRestraint]: {
    label: 'Chemical restraint',
    value: RestrictivePracticeType.ChemicalRestraint,
    raw: RestrictivePracticeType.ChemicalRestraint,
    color: 'green',
  },
  [RestrictivePracticeType.EnvironmentalRestraint]: {
    label: 'Environmental restraint',
    value: RestrictivePracticeType.EnvironmentalRestraint,
    raw: RestrictivePracticeType.EnvironmentalRestraint,
    color: 'blue',
  },
  [RestrictivePracticeType.MechanicalRestraint]: {
    label: 'Mechanical restraint',
    value: RestrictivePracticeType.MechanicalRestraint,
    raw: RestrictivePracticeType.MechanicalRestraint,
    color: 'purple',
  },
  [RestrictivePracticeType.PhysicalRestraint]: {
    label: 'Physical restraint',
    value: RestrictivePracticeType.PhysicalRestraint,
    raw: RestrictivePracticeType.PhysicalRestraint,
    color: 'yellow',
  },
  [RestrictivePracticeType.Seclusion]: {
    label: 'Seclusion',
    value: RestrictivePracticeType.Seclusion,
    raw: RestrictivePracticeType.Seclusion,
    color: 'orange',
  },
  [RestrictivePracticeType.ProhibitedPractice]: {
    label: 'Prohibited practice',
    value: RestrictivePracticeType.ProhibitedPractice,
    raw: RestrictivePracticeType.ProhibitedPractice,
    color: 'red',
  },
};

interface Props extends ChakraV3.TagProps {
  type: RestrictivePracticeType;
}

export const RestrictivePracticeTypeTag = (props: Props) => {
  const { type, ...rest } = props;

  const option = restrictivePracticeTypeOptions[type];

  return (
    <ChakraV3.Tag size='sm' colorPalette={option.color} {...rest}>
      {option.label}
    </ChakraV3.Tag>
  );
};
